/**
 * Validate first name - must be non-empty
 * @param {string} name - First name to validate
 * @returns {boolean} True if valid
 */
export function validateFirstName(name) {
  return name && name.trim().length > 0;
}

/**
 * Validate email address format
 * @param {string} email - Email address to validate
 * @returns {boolean} True if valid email format
 */
export function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return email && emailRegex.test(email.trim());
}

/**
 * Validate investment object
 * @param {Object} investment - Investment to validate
 * @returns {string|null} Error message or null if valid
 */
export function validateInvestment(investment) {
  if (!investment) {
    return 'Investment data is missing';
  }

  if (investment.initialInvestment < 0) {
    return 'Initial investment must be non-negative';
  }

  if (investment.regularAddition < 0) {
    return 'Regular addition must be non-negative';
  }

  if (investment.interestRate < 0) {
    return 'Interest rate must be non-negative';
  }

  if (investment.termInYears <= 0) {
    return 'Term must be positive';
  }

  const validPeriods = ['weekly', 'bi_weekly', 'monthly', 'quarterly', 'semi_annually', 'yearly'];
  if (!validPeriods.includes(investment.additionPeriod)) {
    return 'Invalid addition period';
  }

  if (!validPeriods.includes(investment.interestCompoundedType)) {
    return 'Invalid compound type';
  }

  return null;
}

/**
 * Get user-friendly error message
 * @param {string} error - Original error message
 * @param {Function} t - i18n translation function
 * @returns {string} User-friendly error message
 */
export function getUserFriendlyError(error, t) {
  const errorMap = {
    'firstName is required': t('pdf.error.firstNameRequired'),
    'email is required': t('pdf.error.emailRequired'),
    'email must be a valid email address format': t('pdf.error.emailInvalid'),
    'calculatorData.investments must contain at least one investment': t('pdf.error.noInvestments'),
    'Failed to generate PDF': t('pdf.error.generationFailed'),
  };

  return errorMap[error] || t('pdf.error.unexpected');
}
